import React, { useState } from "react";

import TextField from "../../../Components/UI/Inputs/TextField";
import DateTime from "../../../Components/UI/Inputs/DateTime";
import Button from "../../../Components/UI/Buttons/Button";
import useApi from "../../../Hooks/useApi";
import showToast from "../../../Helpers/toast";
import Common from "../../../Components/Layouts/Common";
import { useNavigate } from "react-router-dom";

const CreateProject = () => {
  const [formData, setFormData] = useState({});
  const { request } = useApi();
  const navigate = useNavigate();

  const handleAddProject = async (e) => {
    e.preventDefault();
    if (
      !formData.projectName ||
      formData.projectName?.trim() === "" ||
      !formData.startDate ||
      !formData.endDate
    ) {
      showToast({ message: "Provide Valid complete data", type: "error" });
      return;
    }
    try {
      const response = await request(
        "POST",
        "/v1/survey/projects",
        { data: formData },
        "survey_service",
      );

      showToast({ message: response.message });
      setTimeout(() => navigate("/projects"), 1500);
    } catch (error) {
      showToast({ message: error?.response?.data?.message, type: "error" });
    }
  };
  const isEndDateValid = () => {
    if (!formData.startDate || !formData.endDate) return true;
    return new Date(formData.endDate) >= new Date(formData.startDate);
  };

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="bg-white relative h-full">
      <Common headline={"Create New Project"}>
        <form
          onSubmit={handleAddProject}
          className="text-start space-y-10 h-full rounded-md  "
        >
          <div className="grid grid-cols-2 gap-2 items-center ">
            <div className="col-span-full">
              <TextField
                type={"text-area"}
                label="Project Title"
                name="projectName"
                // onValueChange={handleInputChange}
                value={formData.projectName}
                onValueChange={handleInputChange}
              />
            </div>

            <DateTime
              label={"Start Date"}
              type="date"
              placeholder="Start Date"
              name="startDate"
              value={formData.startDate}
              onValueChange={handleInputChange}
              required
            />

            <DateTime
              label={"End Date"}
              type="date"
              minDate={formData.startDate}
              placeholder="End Date"
              name="endDate"
              value={formData.endDate}
              onValueChange={handleInputChange}
              required
              min={formData.startDate}
            />
          </div>
          {!isEndDateValid() && (
            <p className="text-red-500 text-sm">
              End date cannot be before start date.
            </p>
          )}

          <div className="flex justify-center ">
            <Button
              type="full"
              label="Submit"
              style={{
                width: "200px",
              }}
              disabled={!isEndDateValid()}
            />
          </div>
        </form>
      </Common>
    </div>
  );
};

export default CreateProject;
